export const getOcplcBusinessModel = `query GetOcplcBusinessModels {
    ocplcBusinessModel {
      businessModels {
        value
        text
      }
    }
  }`;
